<script lang="ts">
  import { page } from '$app/stores';
  import type { InstitutionsReadStoreConfigurationsResponse } from '@do/shop-api';
  import { Icon } from '@shared/ui/icon';

  $: socialLinks = $page.data.configurations
    .social_profiles as InstitutionsReadStoreConfigurationsResponse['social_profiles'];

  $: preparedSocial = socialLinks
    ? socialLinks
        .filter((item) => item.type !== 'site')
        .map((item) => ({
          link: item.value,
          text: item.type,
          target: '_blank',
        }))
    : [];
</script>

{#if preparedSocial.length}
  <div class="flex items-center justify-end gap-8">
    <p class="text-base font-medium uppercase">Follow us</p>

    <ul class="flex items-center justify-end gap-8">
      {#each preparedSocial as link}
        <li>
          <a
            href="{link.link}"
            target="{link.target ?? '_self'}"
            rel="{link.target === '_blank' ? 'nofollow' : ''}"
            class="text-sm font-medium"
          >
            <Icon name="{link.text.toLowerCase()}" width="{20}" height="{20}" />
          </a>
        </li>
      {/each}
    </ul>
  </div>
{/if}
